import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormBuilder,
  UntypedFormGroup,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { Media } from "./photos-select-form.model";

@Component({
  //  moduleId: module.id,
  selector: "app-photos-select",
  styleUrls: ["photos-select-form.component.scss"],
  templateUrl: "photos-select-form.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhotosSelectComponent),
      multi: true,
    },
  ],
})
export class PhotosSelectComponent implements OnInit, ControlValueAccessor {
  @Output() callbackData = new EventEmitter();
  @Output() removeMedia = new EventEmitter<Media>();

  @Input() title: string;
  @Input() label: string;
  @Input() btn: string;
  @Input() file: Media = null;
  @Input() showTitleInlineInMobile = false;
  @Input() withDraft: false;
  @Input() folder: string = null;

  showFullScreen: boolean;

  @Input() private pictureForm: UntypedFormGroup;

  public isNotImage = false;
  public isTooBig = false;
  public isServerError = false;
  public mimeTypeAuthorized: string[] = [
    "image/png",
    "image/gif",
    "image/jpeg",
  ];
  private isDisabled = false;
  // eslint-disable-next-line
  private onTouch: Function = () => {};

  // eslint-disable-next-line
  private onModelChange: Function = (aa) => {};

  // Pour corriger le problème d'unicité du input type=file
  private mediaId: string;

  writeValue(value: Media): void {
    if (value !== undefined) {
      this.file.photo = value.photo;
    }
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
  ) {
    this.pictureForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.mediaId = `newMediaFile${this.file.ndx}`;
  }

  uploadFiles(event) {
    const reader = new FileReader();

    // locate the file element meant for the file upload.
    // get the total amount of files attached to the file input.
    const inputEl: HTMLInputElement = this.el.nativeElement.querySelector(
      `#${this.mediaId}`,
    );
    const fileCount: number = inputEl.files.length;

    if (fileCount > 0) {
      reader.addEventListener(
        "load",
        (result) => {
          const img = result.target["result"];
          const thisfile = this.file;

          thisfile.photo4SafePreview =
            this.sanitizer.bypassSecurityTrustResourceUrl(img as string); // TODO: security breach ?
          thisfile.photo = img as string;

          this.callbackData.emit({
            value: thisfile,
          });
          this.onModelChange(thisfile);
          this.onTouch();

          this.isNotImage = false;
          this.isTooBig = false;
          this.isServerError = false;
        },
        false,
      );

      reader.readAsDataURL(inputEl.files.item(0));
    }
  }

  public deleteFile() {
    this.file.deleted = true;
    this.file.photo = "";
    this.onModelChange(this.file);
    this.onTouch();
    this.removeMedia.emit(this.file);
  }

  public getTransformedURL(url, transformation) {
    return (
      /* eslint-disable */
      url.substring(0, url.indexOf("s--")) +
      transformation +
      url.substring(url.indexOf("--/") + 2)
      /* eslint-enable */
    );
  }
}
